/** @jsxImportSource @emotion/react */
import { Trash2 } from 'lucide-react';
import React from 'react';
import { theme } from 'styles/theme/theme';
import type { DivProps } from 'typings';
import UDButton from '../button';
import * as S from './styles';

interface IProps extends DivProps {
  onDelete?: () => void;
  onCancel?: () => void;
  onSubmit?: () => void;
  cancelText?: string;
  submitText?: string;
  loading: boolean;
}

function UDActions(props: IProps) {
  const { onDelete, onCancel, onSubmit, cancelText: cancel, submitText: submit, loading, ...rest } = props;

  return (
    <S.MainBlock {...rest}>
      {onDelete && (
        <UDButton variant="secondary" type="button" onClick={onDelete} loading={loading}>
          <div className="flex h-full w-full items-center justify-center">
            <Trash2 size={20} color={theme.colors.Red} />
          </div>
        </UDButton>
      )}
      {(onCancel || cancel) && (
        <UDButton variant="secondary" type="button" onClick={onCancel} loading={loading}>
          {cancel}
        </UDButton>
      )}
      {(onSubmit || submit) && (
        <UDButton variant="primary" type="submit" loading={loading}>
          {submit}
        </UDButton>
      )}
    </S.MainBlock>
  );
}

export default UDActions;
